import React from 'react';
import { usePlanningActualState } from '../Context/index';

function AverageSellPriceTableTotal({ years }) {
  const { checkVisible, getOvarAllFieldTotal } = usePlanningActualState();
  const averageSellPrice = [
    {
      keyName: 'plannedASP',
      name: 'Planned Average Sell Price',
    },
    {
      keyName: 'actualASP',
      name: 'Actual Average Sell Price',
    },
  ];
  return (years ?? []).map((currentYear, yearIndex) => {
    return (
      <table key={yearIndex} className="table custom-table layout-fixed  font-13 mr-3">
        <thead>
          <tr>
            {averageSellPrice.map((salesItem, i) => {
              const isVisible = checkVisible(salesItem.keyName);
              return (
                isVisible && (
                  <th key={i} className="w-200px">
                    <span>
                      {currentYear}&nbsp;
                      {salesItem.name}
                    </span>
                  </th>
                )
              );
            })}
          </tr>
        </thead>
        <tbody>
          <tr>
            {averageSellPrice.map((salesItem, i) => {
              const isVisible = checkVisible(salesItem.keyName);
              return isVisible && <td key={i}>{getOvarAllFieldTotal(salesItem.keyName, yearIndex, currentYear)}</td>;
            })}
          </tr>
        </tbody>
      </table>
    );
  });
}
export default AverageSellPriceTableTotal;
